<template>
	<div class="centerPage">
		<div class="search">
			<div class="flex title">
				<span class="tit">预约管理</span>
				<router-link to="/doctor/appointmentSet" class="flex">
					<img src="../../assets/img/set_a.png" alt="" width="20">预约设置
				</router-link>
			</div>
			<div class="flex selected">
				<div class="flex selectBtn">
					<el-button @click="pickDay(-1)" style="background: none;color: #567BFF;margin-right: 10px">前一天</el-button>
					<el-date-picker
						v-model="time"
						@change="changeDatePicker"
						type="date"
						style="width: 130px"
						placeholder="选择日期">
					</el-date-picker>
					<el-button @click="pickDay(1)" style="background: none;color: #567BFF">后一天</el-button>

					<el-checkbox-group v-model="allTime" @change="checkAllTime" size="small" style="margin-left: 10px">
						<el-checkbox>所有时间</el-checkbox>
					</el-checkbox-group>

				</div>
				<div class="flex searchTab">
					<el-radio-group v-model="getCondition.appointState" @change="skipPage(1)" size="small">
						<el-radio-button label="1">待通话</el-radio-button>
						<el-radio-button label="3">待建议</el-radio-button>
						<el-radio-button label="4">已完成</el-radio-button>
					</el-radio-group>

					<el-input placeholder="预约号" clearable v-model="getCondition.appointNo" @change="pageAppoint"></el-input>
					<el-button size="mini" @click="skipPage(1)">搜索</el-button>
				</div>

			</div>
		</div>
		<div class="formUserInfo">
			<div class="cnHomeTabsItem "
				v-for="(obj,index) in appointData"
				:key="index">
				<p class="timezone">
					<span><i class="el-icon-time"></i>&nbsp;{{ obj.appointDateShow }}</span>
				</p>
				<div class="flex appointData">
					<div v-if="obj.headImgPath" class="avatar img" :style="'backgroundImage: url('+obj.headImgPath+')'"></div>
					<div v-else class="avatar img default-user-avatar"></div>
					<div class="rightHome">
						<p>
							<span class="com">预约人：{{ obj.realName }}</span>
							<span class="com">预约号：{{ obj.appointNo }}</span>
						</p>
						<p>
							<span class="com">咨询方式：{{ obj.consultMode === 1 ? '语音' : '视频' }}</span>
							<span class="com" v-if="obj.consultLanguage">咨询语言：{{ obj.consultLanguage }}</span>
						</p>

						<div class="flex ">
							<span class="com">咨询费用：
								<span v-if="obj.initialPayAmount != obj.payAmount" class="del-line">¥{{ obj.initialPayAmount }}</span>
								<span class="cost">{{ fmtAmount(obj) }}</span>
							</span>
							<template v-if="obj.operateCode=='doctor_update'">
								<span class="com cost">等待修改确认</span>
							</template>
							<template v-else>
                <span
									:class="(obj.appointState===0&&obj.payState===0)?'orange'
                        :(obj.appointState===0&&obj.payState===1)?'blue'
                        :obj.appointState===1?'blue'
                        :obj.appointState===2?'cost'
                        :obj.appointState===3?'green'
                        :obj.appointState===4?''
                        :'cost'"
									class="com">
                    {{
                    (obj.appointState === 0 && obj.payState === 0) ? '待付款'
                        : (obj.appointState === 0 && obj.payState === 1) ? '待确认'
                        : obj.appointState === 1 ? '待通话'
                            : obj.appointState === 2 ? '已取消'
                                : obj.appointState === 3 ? '待分析'
                                    : obj.appointState === 4 ? '已结束'
                                    : obj.appointState === 5 ? '已取消'
                                        : '有问题'
                  }}
                </span>
							</template>
							<div class="flex btnGroup">
								<el-button size="mini" type="danger" plain @click=toChatCom(obj.userId)>私聊TA
								</el-button>
								<el-button v-if="obj.operateCode=='patient_update'"
									@click="toConfirm(obj.id)" size="mini" class="solid warn">
									修改申请
								</el-button>
								<el-button v-if="obj.operateCode=='patient_reject'"
									@click="read(obj.id)" size="mini" class="solid warn">
									修改被拒
								</el-button>
								<el-button @click="handleCommand({command:'update',id:obj.id})" size="mini" class="solid warn"
									v-if="obj.appointState===1">修改预约
								</el-button>
								<el-button size="mini" class="solid" v-if="obj.appointState===1"
									@click="toChat(obj)">前往通话
								</el-button>
								<el-button @click="toDetail(obj.appointNo)" size="mini" class="solid">详情</el-button>
								<el-button size="mini" class="solid error" @click="toDetail(obj.appointNo)"
									v-if="obj.appointState === 1">结束
								</el-button>
							</div>

						</div>
					</div>
				</div>
			</div>
			<div class="empty" v-if="appointData.length==0">
				<img src="../../assets/img/no.png" alt="" width="200">
				<p>这里什么都没有</p>
			</div>
			<el-pagination
				class="pagination"
				background
				prev-text="Prev"
				next-text="Next"
				@size-change="handleSizeChange"
				@current-change="skipPage"
				:current-page="currentPage"
				:page-size="pageSize"
				layout="prev, pager, next"
				:total="total">
			</el-pagination>
		</div>

		<updateApprove ref="updateApprove"></updateApprove>
		<updateReject ref="updateReject"></updateReject>
		<updateAppoint ref="updateAppoint"></updateAppoint>

	</div>
</template>

<script>
  import commonjs from "../../api/common";
  import {getAxios} from "../../api/http";
  // import {dropdown, dropdownItem, dropdownMenu} from "element-ui";
  import base from "@/api/common";

  export default {
    name: "reservation",
    data() {
      return {
        code: '', name: '', tel: '', all: '',
        allTime: false, // 所有时间
        selectOne: '',//已选选项
        time: new Date(),//时间段
        reservation: [],

        currentPage: 1,// 当前页
        pageSize: 5,// 每页多少条
        total: 0,//总数
        getCondition: {
          appointNo: '',//预约号码
          leftTime: '',//开始日期
          rightTime: '',//结束日期
          realName: '',//姓名
          mobile: '',//手机号码
          payState: '',//支付状态
          appointState: '1',//预约状态
        },//查询条件
        appointData: [],//预约列表数据


        appointCancelCondition: {
          eventId: '',//appointNo
          reason: '',//原因
        },
        timezone: '',
        timezoneName: '',
      }
    },
    inject: ['reload'],
    components: {
      /*   [dropdown.name]: dropdown,
				 [dropdownMenu.name]: dropdownMenu,
				 [dropdownItem.name]: dropdownItem,*/
      'updateApprove': _ => import('../personalCenter/components/update-approve'),
      'updateReject': _ => import('../personalCenter/components/update-reject'),
      'updateAppoint': _ => import('../personalCenter/components/update-appoint'),
    },
    async mounted() {
      let vm = this;
      await getAxios(commonjs.api.doctor.timezoneSelf).then((res) => {
        if (res.data.status == 'success') {
          vm.timezone = res.data.data;
          // vm.timezoneName = timezone.zoneName(vm.timezone);
        }
      });
      this.pageAppoint();//预约列表获取
    },
    methods: {
      toConfirm(id) {
        this.$refs.updateApprove.getData(id);
      },
      read(id) {
        this.$refs.updateReject.getData(id);
        // this.$refs.updateReject.$data.dialogVisible = true;
      },
      beforeHandleCommand(command, id) {
        return {
          command: command,
          id: id
        }
      },
      handleCommand(command) {
        if (command.command == 'update') {
          getAxios(commonjs.api.appoint.toUpdate.replace("{id}", command.id))
            .then((res) => {
              if (res.data.status == 'success') {
                this.$refs.updateAppoint.$data.dialogVisible = true;
                this.$refs.updateAppoint.$data.appointId = command.id;
                this.$refs.updateAppoint.$data.doctorAccount = localStorage.curAccount || '';
                this.$refs.updateAppoint.$data.selectedNumLimit = res.data.selectedNumLimit;
                this.$refs.updateAppoint.initData();
              } else {
                this.$message.warning(res.data.message)
              }
            })
        }
      },
      toChat(obj) {
        this.$router.push({path: '/chat/doctors/' + obj.id})
        // this.$router.push('/chat/doctors/' + id)
      },
      toChatCom(userId) {
        console.log(userId)
        if (userId) {
          this.$ajax.post(base.api.communication.chat.create.replace('{uid}', userId)).then(res => {
            if (res.data.status === 'success') {
              if (res.data.userType == 1) {
                this.$router.push({name: 'communicate', params: {id: res.data.id}});
              } else if (res.data.userType == 2) {
                this.$router.push({name: 'communicateDoc', params: {id: res.data.id}});
              } else {
                this.$message.error('error');
              }
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('失败');
          })
        }
      },
      toDetail(appointNo) {
        this.$router.push({name: 'reservationDetail', query: {no: appointNo}})
      },
      // 每页多少条
      handleSizeChange(val) {
        this.pageSize = val;
      },
      // 当前页
      skipPage(current) {
        this.currentPage = current;
        this.pageAppoint();//预约列表获取
        this.$nextTick(() => {
          $(".contentIndex").animate({scrollTop: '0px'}, 800);
        });
      },
      //预约列表信息获取
      pageAppoint() {
        let that = this;

        // this.getCondition
        let curDate = new Date(this.time);
        let curDay = curDate.getFullYear() + '/' + (curDate.getMonth() + 1) + '/' + curDate.getDate() + ' 00:00:00';
        let timestamp = new Date(curDay).getTime();

        let data = {
          appointState: that.getCondition.appointState,
          appointNo: that.getCondition.appointNo,
          // timestamp
        };
        if (this.time) {
          data["appointStartLongtime"] = new Date(this.time).setHours(0, 0, 0, 0);
          data["appointEndLongtime"] = new Date(this.time).setHours(23, 59, 59, 0);
        }

        this.$ajax.post(commonjs.api.doctor.reservation.pageByCondition.replace("{page}/{size}", this.currentPage + "/" + this.pageSize), data)
          .then(function (res) {
            if (res.data.status === 'success') {
              res.data.rows.forEach((row) => {
                row.appointDateShow = base.utils.buildShowDate(row.appointStartLongtime, row.appointEndLongtime);
              });
              that.appointData = res.data.rows;
              that.total = res.data.total;
            }
          })
      },
      //多条件查询
      changeCondition() {
        this.getCondition.leftTime = new Date(this.time[0]).Format('yyyy-MM-dd');
        this.getCondition.rightTime = new Date(this.time[1]).Format('yyyy-MM-dd');
        this.pageAppoint();
      },
      selectMethod(value) {
        /*   console.log(this.selectOne)*/
        if (value === 0) {//待确认
          this.getCondition.payState = 1;
          this.getCondition.appointState = value;
        } else if (value >= 1 && value <= 4) {
          this.getCondition.appointState = value;
          this.getCondition.payState = '';
        } else if (value === 5) {//待付款
          this.getCondition.payState = 0;
          this.getCondition.appointState = 0;
        } else {//有问题
          this.getCondition.payState = '';
          this.getCondition.appointState = '';
        }
        this.currentPage = 1;
        this.pageAppoint();
      },
      //取消预约
      cancelAppointMethod(id) {
        this.appointCancelCondition.eventId = id;
        let that = this;
        this.$prompt('请输入原因', '取消预约', {
          confirmButtonText: '提交',
          cancelButtonText: '关闭',
        }).then(({value}) => {
          this.appointCancelCondition.reason = value;
          this.$ajax
            .post(commonjs.api.doctor.reservation.appointCancel, that.appointCancelCondition)
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功');
              } else {
                that.$message.error(res.data.message);
              }
              that.pageAppoint();
            }).catch((err) => {
            console.error(err);
            that.$message.error('操作失败');
          })
        })
      },
      changeDatePicker(date) {
        if (date) {
          this.skipPage(1);
        } else {
          this.allTime = true;
          this.skipPage(1);
        }
      },
      pickDay(n) {
        if (!this.time) {
          this.time = new Date();
        }
        this.allTime = false;
        let date = new Date(new Date(this.time).getTime() + n * 24 * 60 * 60 * 1000);
        this.time = date;
        this.skipPage(1);
      },
      checkAllTime(checked) {
        if (checked) {
          this.time = null;
        } else {
          this.time = new Date();
        }
        this.skipPage(1);
      },
      fmtAmount(item) {
        if (item.couponType == 0) {
          return '¥' + item.payAmount;
        } else if (item.couponType == 1) {
          return '¥' + item.payAmount;
        } else if (item.couponType == 2) {
          if (item.payAmount == 0) {
            return '月卡支付';
          } else {
            return '¥' + item.payAmount + ' 月卡抵扣';
          }
        } else if (item.couponType == 3) {
          if (item.payAmount == 0) {
            return '年卡支付';
          } else {
            return '¥' + item.payAmount + ' 年卡抵扣';
          }
        } else {
          return '-';
        }
      }
    },
    filters: {
      appointTime: function (appointDate, appointTimeSlot) {
        //appointDate: 2020-08-24T00:00:00
        //appointTimeSlot: 20 即二十点到二十一点
        appointDate = new Date(appointDate).Format('yyyy年MM月dd日');
        return appointDate + appointTimeSlot + '至' + (appointTimeSlot + 1) + '时';
      }
    }
  }
</script>

<style scoped lang="scss">
	@import '../../assets/css/reservation.scss';
</style>
